import { render, staticRenderFns } from "./whiteboard.menu.speed.dial.vue?vue&type=template&id=370f180c&"
import script from "./whiteboard.menu.speed.dial.vue?vue&type=script&lang=js&"
export * from "./whiteboard.menu.speed.dial.vue?vue&type=script&lang=js&"
import style0 from "./whiteboard.menu.speed.dial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VIcon,VSpeedDial})
